import { render } from "./OrdersAndInvoices.vue?vue&type=template&id=1d9c8918&scoped=true"
import script from "./OrdersAndInvoices.vue?vue&type=script&lang=js"
export * from "./OrdersAndInvoices.vue?vue&type=script&lang=js"

import "./OrdersAndInvoices.vue?vue&type=style&index=0&id=1d9c8918&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9c8918"]])

export default __exports__